module.exports = __webpack_public_path__ + "static/img/device.b25cd32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/device.jpg
// module id = H81q
// module chunks = 0